import { schema } from "normalizr";

const SaleCommissionSchema = new schema.Entity("saleCommissions");
const SaleCommissionArraySchema = new schema.Array(SaleCommissionSchema);

export { SaleCommissionSchema, SaleCommissionArraySchema };